import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 5,
	height: 10,
	viewBox: "0 0 5 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 1.5L3.82973 5L0.75 8.5",
		stroke: "#009A5D",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRightChevron;
